/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Ref_TitleInputs */

const en_to_xml_ref_title = /** @type {(inputs: To_Xml_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How JSON constructs map to XML`)
};

const ko_to_xml_ref_title = /** @type {(inputs: To_Xml_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON 구성 요소가 XML로 대응되는 방식`)
};

const ja_to_xml_ref_title = /** @type {(inputs: To_Xml_Ref_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON の構成要素が XML に対応する仕組み`)
};

/**
* | output |
* | --- |
* | "How JSON constructs map to XML" |
*
* @param {To_Xml_Ref_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_ref_title = /** @type {((inputs?: To_Xml_Ref_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Ref_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_ref_title(inputs)
	if (locale === "ko") return ko_to_xml_ref_title(inputs)
	return ja_to_xml_ref_title(inputs)
});